<template>
  <div class="comment mt-3" :class="comment.status">
    <div
      class="d-flex mb-4"
      :class="{ 'align-items-center': !comment.group_name }"
    >
      <img alt="user" class="user-picture mr-3" :src="userPicture" />
      <div class="w-100">
        <div class="d-flex">
          <div class="user-name fs-12 fw-5 mr-2 text-neutral-600">
            {{
              comment.moderator_data
                ? comment.moderator_data.name
                : comment.name
                ? comment.name
                : "Usuário sem nome"
            }}
          </div>
          <div class="fs-12 text-neutral-400">
            {{ postDate }}
          </div>
        </div>
        <div v-if="comment.group_name" class="group-name text-neutral-400">
          {{ comment.group_name }}
        </div>
      </div>
    </div>

    <div class="comment-text">
      <span>
        {{ comment.text }}
      </span>
    </div>
  </div>
</template>
<script>
import { timeFromNow } from "@/functions/helpers";
export default {
  props: {
    comment: Object
  },
  computed: {
    postDate() {
      return timeFromNow(this.comment?.created_at, "weeks");
    },
    userPicture() {
      return (
        this.comment.user_photo ||
        require("@/assets/images/avatar-placeholder.png")
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.comment {
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff;
  border-bottom: 3px solid #b9b9bd;
  &.review {
    border-color: #df8a40;
  }
  &.published {
    border-color: #42b364;
  }
  &.blocked {
    opacity: 0.8;
  }
  .comment-text {
    font-size: 14px;
    padding-right: 12px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(59, 59, 74, 0.9);
    white-space: pre-line;
    overflow-wrap: anywhere;
    max-height: 110px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 6px;
      background-color: unset;
    }
    &::-webkit-scrollbar-thumb {
      background: #d0d1ddd9;
      border-radius: 10px;
    }
  }
  .user-picture {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .user-name {
    max-width: calc(100% - 100px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .group-name {
    font-size: 12px;
    white-space: nowrap;
    max-width: calc(100% - 50px);
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
